import { render, staticRenderFns } from "./InstagramSettings.vue?vue&type=template&id=f337f4e0"
import script from "./InstagramSettings.vue?vue&type=script&lang=js"
export * from "./InstagramSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports